import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IKPIType, EKPITypes } from './interfaces';

export const getKPITypeList = (subtype: EKPITypes) => (data: IDynamicTableParams) => {
  return instance()
    .post<IKPIType[]>(`/kpi/type/${subtype}/list`, data)
    .then((response) => response.data);
};

export const getKPITypeListAll = (subtype: EKPITypes) => {
  return instance()
    .post<IKPIType[]>(`/kpi/type/${subtype}/listAll`)
    .then((response) => response.data);
};

export const getKPITypeAvailableColumns = (subtype: EKPITypes) => {
  return instance()
    .post<IAvailableColumnModel[]>(`/kpi/type/${subtype}/availableColumns`)
    .then((response) => response.data);
};

export const getKPITypeAvailableGroupColumns = (subtype: EKPITypes) => () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>(`/kpi/type/${subtype}/availableGroupColumns`)
    .then((response) => response.data);
};

export const loadKPIType = (subtype: EKPITypes, kpiTypeId: number) => {
  return instance()
    .post<IKPIType>(`/kpi/type/${subtype}/load`, { kpiTypeId })
    .then((response) => response.data);
};

export const createKPIType = (subtype: EKPITypes, kpiType: IKPIType) => {
  return instance()
    .post<IKPIType>(`/kpi/type/${subtype}/save`, kpiType)
    .then((response) => response.data);
};

export const updateKPIType = (subtype: EKPITypes, kpiType: IKPIType) => {
  return instance()
    .post<IKPIType>(`/kpi/type/${subtype}/update`, kpiType)
    .then((response) => response.data);
};

export const archiveKPIType = (subtype: EKPITypes, kpiTypeId: number) => {
  return instance()
    .post(`/kpi/type/${subtype}/archive/${kpiTypeId}`)
    .then((response) => response.data);
};

export const recoverKPIType = (subtype: EKPITypes, kpiTypeId: number) => {
  return instance()
    .post(`/kpi/type/${subtype}/recover/${kpiTypeId}`)
    .then((response) => response.data);
};
